var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconService3 = function SvgIconService3(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "#FF2D55",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2D55",
    fillRule: "nonzero",
    d: "M31.498 41.42v-3.238h3.45V27.27c1.372 0 5.244-.07 6.969-.07 7.286 0 9.539 3.168 9.539 7.216 0 4.224-3.133 7.005-8.976 7.005h-3.238v2.921h5.772v3.239h-5.772v4.33h-4.295v-4.33h-3.45v-3.239h3.45v-2.921h-3.45zm10.876-10.172c-.88 0-1.97.035-3.132.07v6.864h3.097c2.535 0 4.541-.88 4.541-3.379 0-2.57-1.584-3.555-4.506-3.555z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconService3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-service-3.0ab6a910.svg";
export { ForwardRef as ReactComponent };